__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-07-22-1784713980-stable-dev/";